import { DEFAULT_LANG, SITE_LANGS, bcp47 } from './constants';

const SITE_ROUTES = {
  choice: ["home", "notFound"],
  global: [
    "home",
    "tours",
    "builder",
    "hotels",
    "country",
    "reviews",
    "gallery",
    "video",
    "contact",
    "articles",
    "article",
    "credits",
    "notFound"
  ],
  umrah: ["home", "paket", "ziyarat", "maksatnama", "suratlar", "yazylmak", "credits", "notFound"]
};
const SITE_BRAND = {
  choice: "Charva Travel",
  global: "Charva Travel",
  umrah: "Charva Umrah"
};
const ROUTE_META = {
  choice: {
    home: {
      ru: {
        title: "Charva Travel \u2014 \u0442\u0443\u0440\u044B \u043F\u043E \u0422\u0443\u0440\u043A\u043C\u0435\u043D\u0438\u0441\u0442\u0430\u043D\u0443 \u0438 \u0443\u043C\u0440\u0430",
        description: "\u0413\u043E\u0442\u043E\u0432\u044B\u0435 \u0442\u0443\u0440\u044B \u0438 \u043A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0442\u043E\u0440 \u043F\u0443\u0442\u0435\u0448\u0435\u0441\u0442\u0432\u0438\u0439 \u043F\u043E \u0422\u0443\u0440\u043A\u043C\u0435\u043D\u0438\u0441\u0442\u0430\u043D\u0443, \u0430 \u0442\u0430\u043A\u0436\u0435 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u043E\u0432\u0430\u043D\u043D\u0430\u044F \u0443\u043C\u0440\u0430 \u0441 \u0442\u0443\u0440\u043A\u043C\u0435\u043D\u0441\u043A\u043E\u0439 \u0433\u0440\u0443\u043F\u043F\u043E\u0439."
      },
      en: {
        title: "Charva Travel \u2014 tours of Turkmenistan and Umrah",
        description: "Ready-made tours and a trip builder for Turkmenistan, plus organised Umrah with a Turkmen-speaking group."
      },
      tr: {
        title: "Charva Travel \u2014 T\xFCrkmenistan turlar\u0131 ve umre",
        description: "T\xFCrkmenistan i\xE7in haz\u0131r turlar ve gezi olu\u015Fturucu, ayr\u0131ca T\xFCrkmence konu\u015Fan grupla organize umre."
      },
      tm: {
        title: "Charva Travel \u2014 T\xFCrkmenistana sy\xFDahat we umra",
        description: "T\xFCrkmenistan bo\xFDun\xE7a ta\xFD\xFDar turlar we sy\xFDahat gurna\xFDjy, \u015Fe\xFDle hem t\xFCrkmen topary bilen umra zi\xFDarady."
      }
    },
    /*
     * The chooser has a 404 of its own, and the address in the description is the point.
     *
     * Every path but `/` and `/<lang>` lands here, and the one that actually arrives is a page
     * of one of the other two sites typed against the apex — `charva-travel.com/ru/gallery` is
     * how the owner found this. So the answer is not «go home», it is «this is the door, the
     * rooms are through there», which is what the chooser already is.
     */
    notFound: {
      ru: {
        title: "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430 \u2014 Charva Travel",
        description: "\u0422\u0430\u043A\u043E\u0433\u043E \u0430\u0434\u0440\u0435\u0441\u0430 \u043D\u0430 charva-travel.com \u043D\u0435\u0442. \u041E\u0442\u0441\u044E\u0434\u0430 \u0434\u0432\u0430 \u043F\u0443\u0442\u0438: \u0442\u0443\u0440\u044B \u043F\u043E \u0422\u0443\u0440\u043A\u043C\u0435\u043D\u0438\u0441\u0442\u0430\u043D\u0443 \u0438 \u0443\u043C\u0440\u0430 \u0441 \u0442\u0443\u0440\u043A\u043C\u0435\u043D\u0441\u043A\u043E\u0439 \u0433\u0440\u0443\u043F\u043F\u043E\u0439."
      },
      en: {
        title: "Page not found \u2014 Charva Travel",
        description: "There is no such address on charva-travel.com. Two ways on from here: tours of Turkmenistan, and Umrah with a Turkmen-speaking group."
      },
      tm: {
        title: "Sahypa tapylmady \u2014 Charva Travel",
        description: "charva-travel.com-da be\xFDle salgy \xFDok. Bu \xFDerden iki \xFDol bar: T\xFCrkmenistana sy\xFDahat we t\xFCrkmen topary bilen umra."
      },
      tr: {
        title: "Sayfa bulunamad\u0131 \u2014 Charva Travel",
        description: "charva-travel.com adresinde b\xF6yle bir sayfa yok. Buradan iki yol var: T\xFCrkmenistan turlar\u0131 ve T\xFCrkmence konu\u015Fan grupla umre."
      }
    }
  },
  global: {
    tours: {
      ru: {
        title: "\u0413\u043E\u0442\u043E\u0432\u044B\u0435 \u0442\u0443\u0440\u044B \u043F\u043E \u0422\u0443\u0440\u043A\u043C\u0435\u043D\u0438\u0441\u0442\u0430\u043D\u0443 \u2014 Charva Travel",
        description: "\u041C\u0430\u0440\u0448\u0440\u0443\u0442\u044B \u043F\u043E \u0422\u0443\u0440\u043A\u043C\u0435\u043D\u0438\u0441\u0442\u0430\u043D\u0443 \u0441 \u043E\u0442\u0435\u043B\u044F\u043C\u0438, \u0433\u0438\u0434\u043E\u043C \u0438 \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u0435\u043C \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432. \u041A\u043B\u0430\u0441\u0441\u0438\u043A\u0430, \u043F\u0443\u0441\u0442\u044B\u043D\u044F, \u0438\u0441\u0442\u043E\u0440\u0438\u044F, \u043A\u0443\u043B\u044C\u0442\u0443\u0440\u0430 \u0438 \u043E\u0442\u0434\u044B\u0445."
      },
      en: {
        title: "Ready-made tours of Turkmenistan \u2014 Charva Travel",
        description: "Routes across Turkmenistan with hotels, a guide and paperwork handled. Classic, desert, history, culture and leisure."
      },
      tr: {
        title: "T\xFCrkmenistan haz\u0131r turlar\u0131 \u2014 Charva Travel",
        description: "Otel, rehber ve belge i\u015Flemleri dahil T\xFCrkmenistan rotalar\u0131. Klasik, \xE7\xF6l, tarih, k\xFClt\xFCr ve dinlence."
      }
    },
    builder: {
      ru: {
        title: "\u0421\u0431\u043E\u0440\u0449\u0438\u043A \u0442\u0443\u0440\u043E\u0432 \u043F\u043E \u0422\u0443\u0440\u043A\u043C\u0435\u043D\u0438\u0441\u0442\u0430\u043D\u0443 \u2014 Charva Travel",
        description: "\u0421\u043E\u0431\u0435\u0440\u0438\u0442\u0435 \u043C\u0430\u0440\u0448\u0440\u0443\u0442 \u0441\u0430\u043C\u0438: \u0433\u043E\u0440\u043E\u0434\u0430, \u0434\u043D\u0438, \u043A\u043B\u0430\u0441\u0441 \u043E\u0442\u0435\u043B\u044F, \u043F\u0438\u0442\u0430\u043D\u0438\u0435, \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442 \u0438 \u044D\u043A\u0441\u043A\u0443\u0440\u0441\u0438\u0438. \u041E\u0442\u043F\u0440\u0430\u0432\u044C\u0442\u0435 \u0437\u0430\u044F\u0432\u043A\u0443 \u2014 \u043E\u043F\u0435\u0440\u0430\u0442\u043E\u0440 \u0440\u0430\u0441\u0441\u0447\u0438\u0442\u0430\u0435\u0442 \u0438 \u043E\u0442\u0432\u0435\u0442\u0438\u0442."
      },
      en: {
        title: "Turkmenistan tour builder \u2014 Charva Travel",
        description: "Build the route yourself: cities, days, hotel class, meals, transport and excursions. Send it over and an operator quotes it."
      },
      tr: {
        title: "T\xFCrkmenistan tur olu\u015Fturucu \u2014 Charva Travel",
        description: "Rotay\u0131 kendiniz kurun: \u015Fehirler, g\xFCnler, otel s\u0131n\u0131f\u0131, yemek, ula\u015F\u0131m ve geziler. G\xF6nderin, operat\xF6r fiyatland\u0131rs\u0131n."
      }
    },
    hotels: {
      ru: {
        title: "\u041E\u0442\u0435\u043B\u0438 \u0422\u0443\u0440\u043A\u043C\u0435\u043D\u0438\u0441\u0442\u0430\u043D\u0430 \u2014 Charva Travel",
        description: "\u041E\u0442\u0435\u043B\u0438 3\u20135 \u2605 \u043F\u043E \u0422\u0443\u0440\u043A\u043C\u0435\u043D\u0438\u0441\u0442\u0430\u043D\u0443 \u043F\u043E\u0434 \u0432\u0430\u0448 \u043C\u0430\u0440\u0448\u0440\u0443\u0442: \u0410\u0448\u0445\u0430\u0431\u0430\u0434, \u041C\u0430\u0440\u044B, \u0414\u0430\u0448\u043E\u0433\u0443\u0437, \u041B\u0435\u0431\u0430\u043F \u0438 \u0410\u0432\u0430\u0437\u0430 \u043D\u0430 \u041A\u0430\u0441\u043F\u0438\u0438."
      },
      en: {
        title: "Hotels in Turkmenistan \u2014 Charva Travel",
        description: "Hotels from three to five stars across Turkmenistan, matched to the route: Ashgabat, Mary, Dashoguz, Lebap and Awaza on the Caspian."
      },
      tr: {
        title: "T\xFCrkmenistan otelleri \u2014 Charva Travel",
        description: "T\xFCrkmenistan genelinde 3\u20135 y\u0131ld\u0131zl\u0131 oteller, rotaya g\xF6re se\xE7ilir: A\u015Fkabat, Mary, Da\u015Foguz, Lebap ve Hazar k\u0131y\u0131s\u0131ndaki Avaza."
      }
    },
    country: {
      ru: {
        title: "\u0422\u0443\u0440\u043A\u043C\u0435\u043D\u0438\u0441\u0442\u0430\u043D: \u043E \u0441\u0442\u0440\u0430\u043D\u0435 \u0438 \u0432\u0438\u0437\u0435 \u2014 Charva Travel",
        description: "\u0424\u0430\u043A\u0442\u044B \u043E \u0422\u0443\u0440\u043A\u043C\u0435\u043D\u0438\u0441\u0442\u0430\u043D\u0435, \u043F\u043E\u0440\u044F\u0434\u043E\u043A \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0432\u0438\u0437\u044B \u043F\u043E \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044E \u0438 \u0448\u0435\u0441\u0442\u044C \u043C\u0435\u0441\u0442, \u0440\u0430\u0434\u0438 \u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u0441\u044E\u0434\u0430 \u0435\u0434\u0443\u0442."
      },
      en: {
        title: "Turkmenistan: the country and visas \u2014 Charva Travel",
        description: "Facts about Turkmenistan, how the invitation-based visa works, and six places people come for."
      },
      tr: {
        title: "T\xFCrkmenistan: \xFClke ve vize \u2014 Charva Travel",
        description: "T\xFCrkmenistan hakk\u0131nda bilgiler, davetiyeli vize s\xFCreci ve u\u011Fruna gelinen alt\u0131 yer."
      }
    },
    reviews: {
      ru: {
        title: "\u041E\u0442\u0437\u044B\u0432\u044B \u043E \u0442\u0443\u0440\u0430\u0445 \u043F\u043E \u0422\u0443\u0440\u043A\u043C\u0435\u043D\u0438\u0441\u0442\u0430\u043D\u0443 \u2014 Charva Travel",
        description: "\u041E\u0442\u0437\u044B\u0432\u044B \u043F\u0443\u0442\u0435\u0448\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u0438\u043A\u043E\u0432 \u043E \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0430\u0445 Charva Travel: \u043E\u0446\u0435\u043D\u043A\u0438, \u0433\u043E\u0440\u043E\u0434\u0430 \u0438 \u0447\u0442\u043E \u0437\u0430\u043F\u043E\u043C\u043D\u0438\u043B\u043E\u0441\u044C."
      },
      en: {
        title: "Reviews of tours in Turkmenistan \u2014 Charva Travel",
        description: "Travellers on Charva Travel routes: ratings, cities and what stayed with them."
      },
      tr: {
        title: "T\xFCrkmenistan tur yorumlar\u0131 \u2014 Charva Travel",
        description: "Charva Travel rotalar\u0131 hakk\u0131nda gezginlerin yorumlar\u0131: puanlar, \u015Fehirler ve ak\u0131lda kalanlar."
      }
    },
    gallery: {
      ru: {
        title: "\u0413\u0430\u043B\u0435\u0440\u0435\u044F \u0422\u0443\u0440\u043A\u043C\u0435\u043D\u0438\u0441\u0442\u0430\u043D\u0430 \u2014 Charva Travel",
        description: "\u0424\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u0438\u0437 \u043F\u043E\u0435\u0437\u0434\u043E\u043A \u043F\u043E \u0422\u0443\u0440\u043A\u043C\u0435\u043D\u0438\u0441\u0442\u0430\u043D\u0443: \u0414\u0430\u0440\u0432\u0430\u0437\u0430, \u041C\u0435\u0440\u0432, \u0410\u0448\u0445\u0430\u0431\u0430\u0434, \u0419\u0430\u043D\u0433\u044B\u043A\u0430\u043B\u0430, \u0410\u0432\u0430\u0437\u0430."
      },
      en: {
        title: "Turkmenistan gallery \u2014 Charva Travel",
        description: "Photographs from trips across Turkmenistan: Darvaza, Merv, Ashgabat, Yangykala, Awaza."
      },
      tr: {
        title: "T\xFCrkmenistan galerisi \u2014 Charva Travel",
        description: "T\xFCrkmenistan gezilerinden foto\u011Fraflar: Darvaza, Merv, A\u015Fkabat, Yang\u0131kala, Avaza."
      }
    },
    video: {
      ru: {
        title: "\u0412\u0438\u0434\u0435\u043E \u043E \u0422\u0443\u0440\u043A\u043C\u0435\u043D\u0438\u0441\u0442\u0430\u043D\u0435 \u2014 Charva Travel",
        description: "\u0412\u0438\u0434\u0435\u043E \u0438\u0437 \u043F\u043E\u0435\u0437\u0434\u043E\u043A \u043F\u043E \u0422\u0443\u0440\u043A\u043C\u0435\u043D\u0438\u0441\u0442\u0430\u043D\u0443: \u043A\u0440\u0430\u0442\u0435\u0440 \u0414\u0430\u0440\u0432\u0430\u0437\u0430, \u041C\u0435\u0440\u0432, \u0430\u0445\u0430\u043B\u0442\u0435\u043A\u0438\u043D\u0441\u043A\u0438\u0435 \u043A\u043E\u043D\u0438."
      },
      en: {
        title: "Video about Turkmenistan \u2014 Charva Travel",
        description: "Video from trips across Turkmenistan: the Darvaza crater, Merv, Akhal-Teke horses."
      },
      tr: {
        title: "T\xFCrkmenistan videolar\u0131 \u2014 Charva Travel",
        description: "T\xFCrkmenistan gezilerinden videolar: Darvaza krateri, Merv, Ahal-Teke atlar\u0131."
      }
    },
    articles: {
      ru: {
        title: "\u0416\u0443\u0440\u043D\u0430\u043B \u043E \u0422\u0443\u0440\u043A\u043C\u0435\u043D\u0438\u0441\u0442\u0430\u043D\u0435 \u2014 Charva Travel",
        description: "\u041A\u0430\u043A \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0432\u0438\u0437\u0443, \u043A\u043E\u0433\u0434\u0430 \u0435\u0445\u0430\u0442\u044C, \u0447\u0442\u043E \u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0432 \u0410\u0448\u0445\u0430\u0431\u0430\u0434\u0435, \u041C\u0435\u0440\u0432\u0435 \u0438 \u0414\u0430\u0440\u0432\u0430\u0437\u0435. \u041F\u0438\u0448\u0435\u043C \u0442\u043E, \u043E \u0447\u0451\u043C \u043D\u0430\u0441 \u0441\u043F\u0440\u0430\u0448\u0438\u0432\u0430\u044E\u0442 \u043F\u0435\u0440\u0435\u0434 \u043F\u043E\u0435\u0437\u0434\u043A\u043E\u0439."
      },
      en: {
        title: "A journal about Turkmenistan \u2014 Charva Travel",
        description: "How the visa works, when to come, what to see in Ashgabat, Merv and Darvaza. The questions people ask us before they travel."
      },
      tr: {
        title: "T\xFCrkmenistan \xFCzerine dergi \u2014 Charva Travel",
        description: "Vize nas\u0131l al\u0131n\u0131r, ne zaman gelinir, A\u015Fkabat, Merv ve Darvaza\u2019da ne g\xF6r\xFCl\xFCr. Yolculuk \xF6ncesi bize sorulanlar."
      }
    },
    home: {
      ru: {
        title: "Charva Travel \u2014 \u0442\u0443\u0440\u044B \u043F\u043E \u0422\u0443\u0440\u043A\u043C\u0435\u043D\u0438\u0441\u0442\u0430\u043D\u0443",
        description: "\u0422\u0443\u0440\u043E\u043F\u0435\u0440\u0430\u0442\u043E\u0440 \u043F\u043E \u0422\u0443\u0440\u043A\u043C\u0435\u043D\u0438\u0441\u0442\u0430\u043D\u0443: \u0433\u043E\u0442\u043E\u0432\u044B\u0435 \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u044B, \u043E\u0442\u0435\u043B\u0438, \u0432\u0438\u0437\u0430 \u043F\u043E \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044E \u0438 \u0433\u0438\u0434. \u0421\u043E\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u0432\u043E\u0439 \u0442\u0443\u0440 \u0438 \u043E\u0442\u043F\u0440\u0430\u0432\u044C\u0442\u0435 \u0437\u0430\u044F\u0432\u043A\u0443."
      },
      en: {
        title: "Charva Travel \u2014 tours of Turkmenistan",
        description: "A tour operator in Turkmenistan: ready-made routes, hotels, visa support and guides. Build your own tour and send it to us."
      },
      tr: {
        title: "Charva Travel \u2014 T\xFCrkmenistan turlar\u0131",
        description: "T\xFCrkmenistan tur operat\xF6r\xFC: haz\u0131r rotalar, oteller, davetiyeli vize ve rehber. Kendi turunuzu kurun ve bize g\xF6nderin."
      }
    },
    contact: {
      ru: {
        title: "\u041E\u043D\u043B\u0430\u0439\u043D-\u0437\u0430\u044F\u0432\u043A\u0430 \u2014 Charva Travel",
        description: "\u0417\u0430\u044F\u0432\u043A\u0430 \u043D\u0430 \u0442\u0443\u0440 \u043F\u043E \u0422\u0443\u0440\u043A\u043C\u0435\u043D\u0438\u0441\u0442\u0430\u043D\u0443: \u043C\u0430\u0440\u0448\u0440\u0443\u0442, \u043E\u0442\u0435\u043B\u0438, \u0432\u0438\u0437\u0430 \u0438 \u0442\u0440\u0430\u043D\u0441\u0444\u0435\u0440. \u041E\u0442\u0432\u0435\u0442 \u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440\u0430 \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 15 \u043C\u0438\u043D\u0443\u0442."
      },
      en: {
        title: "Online enquiry \u2014 Charva Travel",
        description: "Enquire about a tour of Turkmenistan: route, hotels, visa and transfers. A manager replies within 15 minutes."
      },
      tr: {
        title: "\xC7evrimi\xE7i talep \u2014 Charva Travel",
        description: "T\xFCrkmenistan turu talebi: rota, oteller, vize ve transfer. Yetkilimiz 15 dakika i\xE7inde yan\u0131tlar."
      }
    },
    article: {
      ru: {
        title: "\u0416\u0443\u0440\u043D\u0430\u043B \u043E \u0422\u0443\u0440\u043A\u043C\u0435\u043D\u0438\u0441\u0442\u0430\u043D\u0435 \u2014 Charva Travel",
        description: "\u0421\u0442\u0430\u0442\u044C\u0438 \u043E \u043F\u043E\u0435\u0437\u0434\u043A\u0430\u0445 \u043F\u043E \u0422\u0443\u0440\u043A\u043C\u0435\u043D\u0438\u0441\u0442\u0430\u043D\u0443: \u043A\u043E\u0433\u0434\u0430 \u0435\u0445\u0430\u0442\u044C, \u043A\u0430\u043A \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0432\u0438\u0437\u0443, \u0447\u0442\u043E \u043F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C \u0438 \u0447\u0442\u043E \u043F\u0440\u0438\u0432\u0435\u0437\u0442\u0438."
      },
      en: {
        title: "A journal about Turkmenistan \u2014 Charva Travel",
        description: "Articles about travelling in Turkmenistan: when to go, how to get a visa, what to eat and what to bring home."
      },
      tr: {
        title: "T\xFCrkmenistan dergisi \u2014 Charva Travel",
        description: "T\xFCrkmenistan gezileri \xFCzerine yaz\u0131lar: ne zaman gitmeli, vize nas\u0131l al\u0131n\u0131r, ne yenir ve ne getirilir."
      }
    },
    credits: {
      ru: {
        title: "\u0410\u0432\u0442\u043E\u0440\u044B \u0444\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0439 \u2014 Charva Travel",
        description: "\u0421\u043D\u0438\u043C\u043A\u0438 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0432\u0437\u044F\u0442\u044B \u0441 \u0412\u0438\u043A\u0438\u0441\u043A\u043B\u0430\u0434\u0430 \u043F\u043E\u0434 \u0441\u0432\u043E\u0431\u043E\u0434\u043D\u044B\u043C\u0438 \u043B\u0438\u0446\u0435\u043D\u0437\u0438\u044F\u043C\u0438. \u0417\u0434\u0435\u0441\u044C \u043D\u0430\u0437\u0432\u0430\u043D\u044B \u0430\u0432\u0442\u043E\u0440 \u0438 \u043B\u0438\u0446\u0435\u043D\u0437\u0438\u044F \u043A\u0430\u0436\u0434\u043E\u0433\u043E."
      },
      en: {
        title: "Photograph credits \u2014 Charva Travel",
        description: "The photographs on this site come from Wikimedia Commons under free licences. Each one is named here, with its author and licence."
      },
      tr: {
        title: "Foto\u011Fraf k\xFCnyesi \u2014 Charva Travel",
        description: "Bu sitedeki foto\u011Fraflar Wikimedia Commons \xFCzerinden serbest lisanslarla al\u0131nm\u0131\u015Ft\u0131r. Her birinin sahibi ve lisans\u0131 burada."
      }
    },
    notFound: {
      ru: {
        title: "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430 \u2014 Charva Travel",
        description: "\u0412\u043E\u0437\u043C\u043E\u0436\u043D\u043E, \u0441\u0441\u044B\u043B\u043A\u0430 \u0443\u0441\u0442\u0430\u0440\u0435\u043B\u0430. \u041D\u0430\u0447\u043D\u0438\u0442\u0435 \u0441 \u0433\u043B\u0430\u0432\u043D\u043E\u0439 \u0438\u043B\u0438 \u043D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u043D\u0430\u043C \u2014 \u043F\u043E\u0434\u0441\u043A\u0430\u0436\u0435\u043C \u043C\u0430\u0440\u0448\u0440\u0443\u0442."
      },
      en: {
        title: "Page not found \u2014 Charva Travel",
        description: "The link may be out of date. Start from the home page, or write to us and we will point the way."
      },
      tr: {
        title: "Sayfa bulunamad\u0131 \u2014 Charva Travel",
        description: "Ba\u011Flant\u0131 eski olabilir. Ana sayfadan ba\u015Flay\u0131n ya da bize yaz\u0131n, yolu g\xF6sterelim."
      }
    }
  },
  umrah: {
    home: {
      tm: {
        title: "Charva Umrah \u2014 t\xFCrkmen topary bilen umra zi\xFDaraty",
        description: "A\u015Fgabatdan umra: u\xE7ar bileti, wiza, Mekgede we Medinede 4 \u2605 otel, t\xFCrkmen dilli \xFDolba\u015F\xE7y. Topary\u0148 ugra\xFDan senesi we bo\u015F \xFDerler."
      },
      ru: {
        title: "Charva Umrah \u2014 \u0443\u043C\u0440\u0430 \u0441 \u0442\u0443\u0440\u043A\u043C\u0435\u043D\u0441\u043A\u043E\u0439 \u0433\u0440\u0443\u043F\u043F\u043E\u0439",
        description: "\u0423\u043C\u0440\u0430 \u0438\u0437 \u0410\u0448\u0445\u0430\u0431\u0430\u0434\u0430: \u043F\u0435\u0440\u0435\u043B\u0451\u0442, \u0432\u0438\u0437\u0430, \u043E\u0442\u0435\u043B\u0438 4 \u2605 \u0432 \u041C\u0435\u043A\u043A\u0435 \u0438 \u041C\u0435\u0434\u0438\u043D\u0435, \u0441\u043E\u043F\u0440\u043E\u0432\u043E\u0436\u0434\u0430\u044E\u0449\u0438\u0439 \u043D\u0430 \u0442\u0443\u0440\u043A\u043C\u0435\u043D\u0441\u043A\u043E\u043C. \u0414\u0430\u0442\u0430 \u0432\u044B\u043B\u0435\u0442\u0430 \u0438 \u0441\u0432\u043E\u0431\u043E\u0434\u043D\u044B\u0435 \u043C\u0435\u0441\u0442\u0430."
      }
    },
    paket: {
      tm: {
        title: "Umra paketini\u0148 d\xFCz\xFCmi \u2014 Charva Umrah",
        description: "Umra paketine n\xE4me gir\xFD\xE4r: u\xE7ar bileti, wiza, otel, nahar, transfer we t\xFCrkmen dilli \xFDolba\u015F\xE7y. \u015Eertler we \xFDazyly\u015F tertibi."
      },
      ru: {
        title: "\u0421\u043E\u0441\u0442\u0430\u0432 \u043F\u0430\u043A\u0435\u0442\u0430 \u0443\u043C\u0440\u044B \u2014 Charva Umrah",
        description: "\u0427\u0442\u043E \u0432\u0445\u043E\u0434\u0438\u0442 \u0432 \u043F\u0430\u043A\u0435\u0442 \u0443\u043C\u0440\u044B: \u043F\u0435\u0440\u0435\u043B\u0451\u0442, \u0432\u0438\u0437\u0430, \u043E\u0442\u0435\u043B\u044C, \u043F\u0438\u0442\u0430\u043D\u0438\u0435, \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442 \u0438 \u0441\u043E\u043F\u0440\u043E\u0432\u043E\u0436\u0434\u0430\u044E\u0449\u0438\u0439 \u043D\u0430 \u0442\u0443\u0440\u043A\u043C\u0435\u043D\u0441\u043A\u043E\u043C. \u0423\u0441\u043B\u043E\u0432\u0438\u044F \u0438 \u043F\u043E\u0440\u044F\u0434\u043E\u043A \u0437\u0430\u043F\u0438\u0441\u0438."
      }
    },
    ziyarat: {
      tm: {
        title: "Zi\xFDarat \xFDerleri \u2014 Charva Umrah",
        description: "Masjid al-Haram, Masjid an-Nabawi, Uhud, Bedir, Kuba we be\xFDleki zi\xFDarat \xFDerleri \u2014 umra maksatnamasynda."
      },
      ru: {
        title: "\u041C\u0435\u0441\u0442\u0430 \u0437\u0438\u044F\u0440\u0430\u0442\u0430 \u2014 Charva Umrah",
        description: "\u041C\u0430\u0441\u0434\u0436\u0438\u0434 \u0430\u043B\u044C-\u0425\u0430\u0440\u0430\u043C, \u041C\u0430\u0441\u0434\u0436\u0438\u0434 \u0430\u043D-\u041D\u0430\u0431\u0430\u0432\u0438, \u0423\u0445\u0443\u0434, \u0411\u0430\u0434\u0440, \u041A\u0443\u0431\u0430 \u0438 \u0434\u0440\u0443\u0433\u0438\u0435 \u043C\u0435\u0441\u0442\u0430 \u0437\u0438\u044F\u0440\u0430\u0442\u0430 \u0432 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0435 \u0443\u043C\u0440\u044B."
      }
    },
    maksatnama: {
      tm: {
        title: "Umra maksatnamasy g\xFCn-g\xFCnden \u2014 Charva Umrah",
        description: "A\u015Fgabatdan ugramakdan dolanmaga \xE7enli umra maksatnamasy: Mekge, Medine, Bedir we Uhud zi\xFDaratlary."
      },
      ru: {
        title: "\u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0430 \u0443\u043C\u0440\u044B \u043F\u043E \u0434\u043D\u044F\u043C \u2014 Charva Umrah",
        description: "\u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0430 \u0443\u043C\u0440\u044B \u043E\u0442 \u0432\u044B\u043B\u0435\u0442\u0430 \u0438\u0437 \u0410\u0448\u0445\u0430\u0431\u0430\u0434\u0430 \u0434\u043E \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0435\u043D\u0438\u044F: \u041C\u0435\u043A\u043A\u0430, \u041C\u0435\u0434\u0438\u043D\u0430, \u0437\u0438\u044F\u0440\u0430\u0442\u044B \u0411\u0430\u0434\u0440\u0430 \u0438 \u0423\u0445\u0443\u0434\u0430."
      }
    },
    suratlar: {
      tm: {
        title: "Toparlarymyzy\u0148 suratlary \u2014 Charva Umrah",
        description: "Umra toparlarymyzy\u0148 suratlary we wideolary: Mekge, Medine, Bedir we Uhud."
      },
      ru: {
        title: "\u0424\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u043D\u0430\u0448\u0438\u0445 \u0433\u0440\u0443\u043F\u043F \u2014 Charva Umrah",
        description: "\u0424\u043E\u0442\u043E \u0438 \u0432\u0438\u0434\u0435\u043E \u0433\u0440\u0443\u043F\u043F \u0443\u043C\u0440\u044B: \u041C\u0435\u043A\u043A\u0430, \u041C\u0435\u0434\u0438\u043D\u0430, \u0411\u0430\u0434\u0440 \u0438 \u0423\u0445\u0443\u0434."
      }
    },
    yazylmak: {
      tm: {
        title: "Topara \xFDazylmak \u2014 Charva Umrah",
        description: "Umra toparyna onla\xFDn arza: ady, telefony we adam sany. \xDDolba\u015F\xE7y ja\u0148 edip \u015Fertleri d\xFC\u015F\xFCndirer."
      },
      ru: {
        title: "\u0417\u0430\u043F\u0438\u0441\u0430\u0442\u044C\u0441\u044F \u0432 \u0433\u0440\u0443\u043F\u043F\u0443 \u2014 Charva Umrah",
        description: "\u041E\u043D\u043B\u0430\u0439\u043D-\u0437\u0430\u044F\u0432\u043A\u0430 \u0432 \u0433\u0440\u0443\u043F\u043F\u0443 \u0443\u043C\u0440\u044B: \u0438\u043C\u044F, \u0442\u0435\u043B\u0435\u0444\u043E\u043D \u0438 \u0447\u0438\u0441\u043B\u043E \u0447\u0435\u043B\u043E\u0432\u0435\u043A. \u0421\u043E\u043F\u0440\u043E\u0432\u043E\u0436\u0434\u0430\u044E\u0449\u0438\u0439 \u043F\u043E\u0437\u0432\u043E\u043D\u0438\u0442 \u0438 \u043E\u0431\u044A\u044F\u0441\u043D\u0438\u0442 \u0443\u0441\u043B\u043E\u0432\u0438\u044F."
      }
    },
    credits: {
      tm: {
        title: "Suratlary\u0148 awtorlary \u2014 Charva Umrah",
        description: "Sa\xFDtdaky suratlar Wikimedia Commons-dan erkin ygty\xFDarnamalar bilen alyndy. Her birini\u0148 awtory we ygty\xFDarnamasy \u015Fu \xFDerde."
      },
      ru: {
        title: "\u0410\u0432\u0442\u043E\u0440\u044B \u0444\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0439 \u2014 Charva Umrah",
        description: "\u0421\u043D\u0438\u043C\u043A\u0438 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0432\u0437\u044F\u0442\u044B \u0441 \u0412\u0438\u043A\u0438\u0441\u043A\u043B\u0430\u0434\u0430 \u043F\u043E\u0434 \u0441\u0432\u043E\u0431\u043E\u0434\u043D\u044B\u043C\u0438 \u043B\u0438\u0446\u0435\u043D\u0437\u0438\u044F\u043C\u0438. \u0417\u0434\u0435\u0441\u044C \u043D\u0430\u0437\u0432\u0430\u043D\u044B \u0430\u0432\u0442\u043E\u0440 \u0438 \u043B\u0438\u0446\u0435\u043D\u0437\u0438\u044F \u043A\u0430\u0436\u0434\u043E\u0433\u043E."
      }
    },
    notFound: {
      tm: {
        title: "Sahypa tapylmady \u2014 Charva Umrah",
        description: "Belki salgy k\xF6neldi. Ba\u015F sahypadan ba\u015Fla\u0148 \xFDa-da topara \xFDazyly\u0148 \u2014 \xFDolba\u015F\xE7y ja\u0148 eder."
      },
      ru: {
        title: "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430 \u2014 Charva Umrah",
        description: "\u0412\u043E\u0437\u043C\u043E\u0436\u043D\u043E, \u0441\u0441\u044B\u043B\u043A\u0430 \u0443\u0441\u0442\u0430\u0440\u0435\u043B\u0430. \u041D\u0430\u0447\u043D\u0438\u0442\u0435 \u0441 \u0433\u043B\u0430\u0432\u043D\u043E\u0439 \u0438\u043B\u0438 \u0437\u0430\u043F\u0438\u0448\u0438\u0442\u0435\u0441\u044C \u0432 \u0433\u0440\u0443\u043F\u043F\u0443 \u2014 \u0441\u043E\u043F\u0440\u043E\u0432\u043E\u0436\u0434\u0430\u044E\u0449\u0438\u0439 \u043F\u043E\u0437\u0432\u043E\u043D\u0438\u0442."
      }
    }
  }
};
function routeMeta(site, route, lang) {
  const perLang = ROUTE_META[site][route];
  if (perLang === void 0) {
    throw new Error(`No head copy for ${site}/${route}`);
  }
  return perLang[lang] ?? perLang[DEFAULT_LANG[site]] ?? { title: SITE_BRAND[site], description: "" };
}
const HOTEL_KIND = {
  hotel: { ru: "\u043E\u0442\u0435\u043B\u044C", en: "hotel", tr: "otel" },
  boutique: { ru: "\u0431\u0443\u0442\u0438\u043A-\u043E\u0442\u0435\u043B\u044C", en: "boutique hotel", tr: "butik otel" },
  camp: { ru: "\u043B\u0430\u0433\u0435\u0440\u044C", en: "camp", tr: "kamp" }
};
function hotelQualifier(lang, hotel) {
  const kind = HOTEL_KIND[hotel.category]?.[lang] ?? HOTEL_KIND["hotel"]?.[lang] ?? "";
  const rated = kind === "" ? "" : hotel.stars === null ? kind : `${kind} ${String(hotel.stars)}\u2605`;
  return [rated, hotel.city].filter((part) => part !== "").join(", ");
}
function contentMeta(site, content) {
  const summary = content.summary ?? "";
  const qualifier = content.qualifier ?? "";
  const named = qualifier === "" ? content.name : `${content.name} \u2014 ${qualifier}`;
  return {
    // The brand stays the *last* segment whatever else is in front of it: `anchorText` strips
    // exactly that suffix to build a link's text, and a title that ends any other way would put
    // «Charva Travel» into every anchor on the fallback body.
    title: `${named} \u2014 ${SITE_BRAND[site]}`,
    // Long descriptions are cut by every consumer of them anyway, and cut mid-word. 160
    // characters is where Google stops and where a Telegram card stops looking deliberate.
    description: summary.length > 160 ? `${summary.slice(0, 157).trimEnd()}\u2026` : summary
  };
}
const BREADCRUMB_HOME = {
  ru: "\u0413\u043B\u0430\u0432\u043D\u0430\u044F",
  en: "Home",
  tr: "Ana sayfa",
  tm: "Ba\u015F sahypa"
};
const BREADCRUMB_SECTION = {
  "global/tours": {
    name: { ru: "\u0422\u0443\u0440\u044B", en: "Tours", tr: "Turlar", tm: "Turlar" },
    path: "/tours"
  },
  "global/hotels": {
    name: { ru: "\u041E\u0442\u0435\u043B\u0438", en: "Hotels", tr: "Oteller", tm: "Oteller" },
    path: "/hotels"
  },
  "global/article": {
    name: { ru: "\u0416\u0443\u0440\u043D\u0430\u043B", en: "Journal", tr: "Dergi", tm: "\u017Durnal" },
    path: "/articles"
  },
  "umrah/ziyarat": {
    name: {
      ru: "\u041C\u0435\u0441\u0442\u0430 \u0437\u0438\u044F\u0440\u0430\u0442\u0430",
      en: "Ziyarat places",
      tr: "Ziyaret yerleri",
      tm: "Zi\xFDarat \xFDerleri"
    },
    path: "/ziyarat"
  }
};
function breadcrumbHome(lang) {
  return BREADCRUMB_HOME[lang];
}
function breadcrumbSection(site, route, lang) {
  const section = BREADCRUMB_SECTION[`${site}/${route}`];
  if (section === void 0) return null;
  return { name: section.name[lang], path: section.path };
}
function hreflangSet(site) {
  const langs = SITE_LANGS[site];
  return [
    ...langs.map((lang) => ({ hreflang: bcp47(lang), lang })),
    { hreflang: "x-default", lang: DEFAULT_LANG[site] }
  ];
}

export { SITE_BRAND, SITE_ROUTES, breadcrumbHome, breadcrumbSection, contentMeta, hotelQualifier, hreflangSet, routeMeta };
//# sourceMappingURL=seo.js.map
//# sourceMappingURL=seo.js.map